import React, { useEffect } from "react";
import { useState } from "react";
import { Col, Pagination, Row, Tab, Tabs } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {
  DeleteData,
  GetFunction,
  SubmitResponse,
  capitalizeFirstLetter,
  convertDate,
  handleimageUrl,
} from "../../utils/ApiFunctions";
import Question from "../../assets/img/question-mark.svg";

import moment from "moment/moment";
import Edit from "../../assets/img/edit-icon.svg";
import Delete from "../../assets/img/delete-icon.svg";
import Save from "../../assets/img/save.png";
import Grade from "../../assets/img/grade-1.svg";
import Star from "../../assets/img/student-profile.svg";
import Download from "../../assets/img/download.svg";
import Clock from "../../assets/img/clock.svg";
import Calendar from "../../assets/img/calendar-color.svg";
import { toast } from "react-toastify";
import DeleteAlertBox from "../../Component/DeleteAlertBox";
import { useLocalization } from "../../Component/Localization/Localization";
import Loader from "../../Component/Loader/Loader";
import Pagination2 from "../../Component/CutomPagination2";

function Listing() {
  const { t, locale } = useLocalization();
  const [loader, setLoader] = useState(false);

  const { assessmentType } = useParams();
  const [assignMentList, setAssignmentList] = useState([]);
  const user = localStorage.getItem("user_id");
  const [ueserids, setUserList] = useState([]);

  const [deletemopdal, setDeleteModal] = useState(false);
  const [deleteid, setDeleteId] = useState("");
  const usr = localStorage.getItem("user_id");
  const [type, setType] = useState("byme");
  const [page, setPage] = useState(1);

  const [totalPages, setTotalPages] = useState(1);

  async function GetList() {
    const res = await GetFunction(
      `/assignments/list?page=${page}&limit=${10}&isPost=${
        type == "byme" ? false : true
      }&category=${assessmentType}`
    );
    if (res.status == 200) {
      setLoader(false);
      setAssignmentList(res?.data?.data);
      setTotalPages(res?.data?.pagination?.totalPages);
    }
  }

  useEffect(() => {
    setLoader(true);
    setAssignmentList("");
    GetList();
  }, [type, page, assessmentType]);

  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= totalPages; i++) {
      pageNumbers.push(
        <li
          key={i}
          className={page === i ? "active-btn pagination-li" : "pagination-li"}
        >
          <button onClick={() => handlePageChange(i)}>{i}</button>
        </li>
      );
    }
    return pageNumbers;
  };

  const AddToPublic = async (val) => {
    const res = await GetFunction(`assignments/post/${val?._id}`);
    if (res.status == 200) {
      toast.success(res?.data?.message);
      GetList();
    }
  };
  const handlePageChange = (val) => {
    setPage(val);
  };

  const DownloaImag = (url, filename) => {
    fetch(url)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to download image");
        }
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(blobUrl);
      })
      .catch((error) => {
        console.error(error);
        // Handle the error here (e.g., show an error message)
      });
  };

  const DeleteData = async (id) => {
    const data = {
      id,
    };
    const res = await SubmitResponse(`assignments/delete`, data);
    if (res.status == 200) {
      setDeleteModal(false);
      GetList();
    }
  };
  const SaveAssigneMent = async (data) => {
    const res = await GetFunction(`assignments/save/${data?._id}`);
    if (res.status == 200) {
      toast.success(res?.data?.message);
      GetList();
    }
  };

  return (
    <div id="main" class="main-section-login">
      <section class="all-star-gallery">
        <div className="section-heading plage-steps-dtl my-4">
          <h2 className="justify-content-between">
            {" "}
            {assessmentType == "awarenessCourses"
              ? t("awareness_courses")
              : assessmentType == "worksheet"
              ? t("worksheet")
              : assessmentType == "lab"
              ? t("lab")
              : assessmentType == "assessment"
              ? t("assesment")
              : ""}
            <Link
              className="btn-btn-primary float-end"
              to={`/elibary/${assessmentType}`}
            >
              + {t("add")}{" "}
              {assessmentType == "awarenessCourses"
                ? t("awareness_courses")
                : assessmentType == "worksheet"
                ? t("worksheet")
                : assessmentType == "lab"
                ? t("lab")
                : assessmentType == "assessment"
                ? t("assesment")
                : ""}
            </Link>
          </h2>
        </div>
      </section>
      <section className="profile-aection bg-light new-class my-3">
        <div className="p-3">
          <Tabs
            defaultActiveKey="byme"
            // id="uncontrolled-tab-example"
            onSelect={(k) => {
              setType(k);
              setPage(1);
            }}
            className="star-atendance mt-3 "
          >
            <Tab eventKey="byme" title={t("my_self")} className="mt-3">
              <Row>
                {loader && <Loader />}
                {assignMentList &&
                  assignMentList?.map((val, i) => (
                    <Col md={8} key={i}>
                      <div class="my-info px-0 shadow-none h-auto">
                        <h2 className="mx-2">
                          {val?.title}

                          <ul className="box-action-icon">
                            <li>
                              <Link
                                to={`/questions/review/${assessmentType}/${val?._id}`}
                              >
                                <img src={Question} />
                              </Link>
                            </li>
                            <li>
                              <Link
                                to={`/elibary/${assessmentType}/${val?._id}`}
                              >
                                <img src={Edit} />
                              </Link>
                            </li>
                            <li
                              onClick={() => {
                                setDeleteModal(true);
                                setDeleteId(val?._id);
                              }}
                            >
                              <img src={Delete} />
                            </li>
                          </ul>
                        </h2>

                        <ul className="dtl-brder">
                          <li>
                            <i>
                              <img src={Question} />
                            </i>
                            {t("assg_nu")}:<span> {val?.assignmentNo}</span>
                          </li>

                          <li>
                            <i>
                              <img src={Question} />
                            </i>{" "}
                            {t("assignment_type")}:
                            <span>
                              {assessmentType == "awarenessCourses"
                                ? "Awareness & Courses"
                                :  capitalizeFirstLetter(assessmentType)}
                            </span>
                          </li>

                          <li>
                            <i>
                              <img src={Calendar} />
                            </i>
                            {t("post_date")}:
                            <span>
                              {" "}
                              {moment(val?.createdAt).format("DD/MM/YYYY")}
                              <span className="float-end">
                                <i>
                                  <img src={Clock} />
                                </i>{" "}
                                {t("post_time")}:{convertDate(val?.createdAt)}
                              </span>
                            </span>
                          </li>

                          <li>
                            <i>
                              <img src={Question} />
                            </i>
                            {t("subject")}:<span> {val?.subject?.name}</span>
                          </li>
                          <li>
                            <i>
                              <img src={Question} />
                            </i>
                            {t("Class")}:<span> {val?.class?.name}</span>
                          </li>

                          <li>
                            <i>
                              <img src={Question} />
                            </i>
                            {t("term")}:<span> {val?.term}</span>
                          </li>

                          {
                            // assessmentType == "lab" ||
                            // assessmentType == "assessment"
                            // ?
                            <>
                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("total_questions")}:
                                <span> {val?.totalQuestions}</span>
                              </li>
                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("total_marks")}:
                                <span> {val?.totalMarks}</span>
                              </li>
                            </>
                            //  : (
                            //   ""
                            // )
                          }

                          {val?.link && (
                            <li>
                              <span>{val?.link}</span>
                            </li>
                          )}
                        </ul>
                        <center>
                          <button
                            className="cmn-new-btn p-3"
                            onClick={() => AddToPublic(val)}
                          >
                            {t("post_in")}
                          </button>
                        </center>
                      </div>
                    </Col>
                  ))}
                {assignMentList?.length == 0 && !loader && (
                  <center>
                    <h3>{t("no_data_found")}</h3>
                  </center>
                )}
              </Row>
            </Tab>

            <Tab eventKey="public" title={t("public")} className="mt-3">
              <Row>
                {loader && <Loader />}

                {assignMentList &&
                  assignMentList?.map((val, i) => (
                    <Col md={8} key={i}>
                      <div class="my-info px-0 shadow-none h-auto">
                        <h2 className="mx-2">
                          {val?.title}

                          <ul className="box-action-icon">
                            {val?.user?._id !== user && (
                              <>
                                <li>
                                  <Link
                                    to={`/questions/review/${assessmentType}/${val?._id}`}
                                  >
                                    <img src={Question} />
                                  </Link>
                                </li>
                                {/* <li>
                                  <img
                                    src={Save}
                                    style={{ height: "15px", width: "15px" }}
                                    onClick={() => {
                                      SaveAssigneMent(val);
                                    }}
                                  />
                                </li> */}
                              </>
                            )}
                            {val?.user?._id == user && (
                              <>
                                <li>
                                  <Link
                                    to={`/questions/review/${assessmentType}/${val?._id}`}
                                  >
                                    <img src={Question} />
                                  </Link>
                                </li>
                                <li>
                                  <Link
                                    to={`/elibary/${assessmentType}/${val?._id}`}
                                  >
                                    <img src={Edit} />
                                  </Link>
                                </li>
                                <li>
                                  <img
                                    src={Delete}
                                    onClick={() => {
                                      setDeleteModal(true);
                                      setDeleteId(val?._id);
                                    }}
                                  />
                                </li>
                              </>
                            )}
                          </ul>
                        </h2>
                        <ul className="dtl-brder">
                          <li>
                            <i>
                              <img src={Question} />
                            </i>
                            {t("assg_nu")}:<span> {val?.assignmentNo}</span>
                          </li>

                          <li>
                            <i>
                              <img src={Question} />
                            </i>
                            {t("assignment_type")}:
                            <span>
                              {" "}
                              {assessmentType == "awarenessCourses"
                                ? "Awareness & Courses"
                                : capitalizeFirstLetter(assessmentType)}
                            </span>
                          </li>

                          <li>
                            <i>
                              <img src={Calendar} />
                            </i>
                            {t("post_date")}:
                            <span>
                              {" "}
                              {moment(val?.createdAt).format("DD/MM/YYYY")}
                              <span className="float-end">
                                <i>
                                  <img src={Clock} />
                                </i>{" "}
                                {t("post_time")}:{convertDate(val?.createdAt)}
                              </span>
                            </span>
                          </li>

                          <li>
                            <i>
                              <img src={Question} />
                            </i>
                            {t("subject")}:<span> {val?.subject?.name}</span>
                          </li>
                          <li>
                            <i>
                              <img src={Question} />
                            </i>
                            {t("Class")}:<span> {val?.class?.name}</span>
                          </li>

                          <li>
                            <i>
                              <img src={Question} />
                            </i>
                            {t("term")}:<span> {val?.term}</span>
                          </li>

                          {
                            // assessmentType == "lab"
                            // ||
                            // assessmentType == "assessment"
                            // ?
                            <>
                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("total_questions")}:
                                <span> {val?.totalQuestions}</span>
                              </li>
                              <li>
                                <i>
                                  <img src={Question} />
                                </i>
                                {t("total_marks")}:
                                <span> {val?.totalMarks}</span>
                              </li>
                            </>
                            // : (
                            //   ""
                            // )
                          }

                          {val?.link && (
                            <li>
                              <span>{val?.link}</span>
                            </li>
                          )}
                        </ul>

                        {val?.user?._id == user && (
                          <center>
                            <button
                              className="cmn-new-btn p-3"
                              onClick={() => AddToPublic(val)}
                            >
                              {t("stop_post")}
                            </button>
                          </center>
                        )}
                      </div>
                    </Col>
                  ))}
                {assignMentList?.length == 0 && !loader && (
                  <center>
                    <h3>{t("no_data_found")}</h3>
                  </center>
                )}
              </Row>
            </Tab>
          </Tabs>
          {assignMentList?.length > 0 && (
            <Pagination2
              total={totalPages}
              current={page}
              pagination={handlePageChange}
            />
          )}
          {/* <Pagination>{renderPageNumbers()}</Pagination> */}
        </div>
      </section>

      <DeleteAlertBox
        show={deletemopdal}
        onHide={() => setDeleteModal(false)}
        CallDeleteApi={() => DeleteData(deleteid)}
        // heading="Are You Sure Delete Assignment"
        heading={t("assignment_delete")}
      />
    </div>
  );
}

export default Listing;
